import { render, staticRenderFns } from "./Post2432.vue?vue&type=template&id=37a28d6c"
import script from "./Post2432.vue?vue&type=script&lang=js"
export * from "./Post2432.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports